export class MySkillVerificationsConstants{
    public static readonly MySkillVerifications_TopBarTitle: string = 'My Skill Verifications';
    public static readonly MySkillVerifications_CheckBoxHoverToolTip: string = 'By default only Skills needing to be verified by you are displayed. Check this check box to display all the other Skills under your scope that require verification in their life cycle.';
    public static readonly MySkillVerifications_ShowAllLabel: string = 'Show All';
    public static readonly MySkillVerifications_ShowInformationIconCheckbox: boolean = true;
    public static readonly MySkillVerifications_IsIncludeAll: boolean = false;
    public static readonly MySkillVerifications_PanelListType = 'skillVerification';
    
    // Severity constants
    public static readonly MySkillVerifications_Severity_Err: string = 'error';
    public static readonly MySkillVerifications_Severity_Success: string = 'success';
    public static readonly MySkillVerifications_Severity_Warning: string = 'warn';
    
    // Status display constants
    public static readonly MySkillVerifications_PendingAcknowledgement: string = 'Pending Acknowledgement';
    public static readonly MySkillVerifications_PendingVerification : string = 'Pending Verification';
    public static readonly MySkillVerifications_TrainingStatus_Completed: string = 'complete';
    public static readonly MySkillVerifications_LinkedTrainingItemsPreviewCount: number = 1;
    
    // Message constants - Verify Skills
    public static readonly MySkillVerifications_Msg_NoSkillSelected: string = 'Please select at least one skill to verify';
    public static readonly MySkillVerifications_Msg_FailedExtractPuid: string = 'Failed to extract user PUID from selected skills';
    public static readonly MySkillVerifications_Msg_VerifySuccess: string = 'skill(s) verified successfully';
    public static readonly MySkillVerifications_Msg_VerifyFailed: string = 'Failed to verify skills. Please try again.';
    
    // Message constants - Revoke Training
    public static readonly MySkillVerifications_Msg_ExtractPuidFailed: string = 'Failed to extract user PUID. Please try again.';
    public static readonly MySkillVerifications_Msg_RevokeSuccess: string = 'Training occurrences revoked successfully';
    public static readonly MySkillVerifications_Msg_RevokeFailed: string = 'Failed to revoke training occurrences. Please try again.';
    
    // Message constants - Deny/Remove Skill
    public static readonly MySkillVerifications_Msg_RemoveSuccess: string = 'Skill removed successfully';
    public static readonly MySkillVerifications_Msg_RemoveFailed: string = 'Failed to remove skill. Please try again.';
    
    // Message key constants
    public static readonly MySkillVerifications_MessageKey_Toast: string = 'skillVerificationToast';
    
    // Toast notification duration (milliseconds)
    public static readonly MySkillVerifications_ToastNotificationLifespan_Ms: number = 3000;
    
    // Message constants - Training Revocation
    public static readonly MySkillVerifications_Msg_TrainingNotUpdated: string = 'Training Requirements Not Updated';
    public static readonly MySkillVerifications_Msg_TrainingNotUpdatedDetail: string = 'The following Training Requirements have not been updated because they are not in a Complete Training Status and cannot be revoked: ';
    public static readonly MySkillVerifications_Msg_TrainingRevocationSuccess: string = 'Training revocation successful';
    public static readonly MySkillVerifications_Msg_TrainingRevocationSuccessDetail: string = 'The training items have been successfully revoked.';
    public static readonly MySkillVerifications_Msg_TrainingRevocationFailed: string = 'Failed to revoke training. Please try again.';
    
    // Status constants
    public static readonly MySkillVerifications_Status_PendingAcknowledgement: string = 'PendingAcknowledgement';
    public static readonly MySkillVerifications_Status_PendingVerification: string = 'PendingVerification';
    public static readonly MySkillVerifications_Status_Earned: string = 'Earned';
    public static readonly MySkillVerifications_Status_Removed: string = 'Removed';
    
    // UI/Navigation constants
    public static readonly MySkillVerifications_Route_SkillDetails: string = '/eqms.skillDetails/';
    public static readonly MySkillVerifications_Window_Target: string = '_blank';
}